<mat-checkbox
  [class.indeterminate]="indeterminate()"
  [indeterminate]="indeterminate()"
  [color]="color()"
  class="color-{{ color() }}"
  [class.contrast]="contrast()"
  [disabled]="disabled()"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()"
  matTooltipClass="error-tooltip"
  [(ngModel)]="value"
  (click)="onTouch()">
  {{ label() }}
</mat-checkbox>
